import { Injectable } from '@angular/core';
import { NgxFormFields } from '../components/ngx-form.interfaces';

// Humanize a string
// From: https://stackoverflow.com/a/28339742/477550
const /** @type {?} */ humanize = str =>
  str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, m => m.toUpperCase())
export class NgxFormsService {
/**
 * @param {?} fields
 * @return {?}
 */
parseFields(fields: NgxFormFields): any[] {
    return Object.keys(fields).map(fieldName => {
      // Get the field definition and type
      const /** @type {?} */ fieldDef = fields[fieldName]
      const /** @type {?} */ fieldType = fieldDef['type'] || 'input'

      // If the field definition is a string then that serves as the type and will use the inputs default options
      return typeof fieldDef === 'string' ? this[fieldDef](fieldName) : this[fieldType](fieldName, fieldDef)
    })
  }
/**
 * @param {?=} type
 * @param {?=} templateType
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
field(type = 'input', templateType = 'text', key: string = null, options: any = {}) {
    const /** @type {?} */ fieldType = type !== 'input' ? type : templateType

    // Set the default model key name
    key = key || fieldType

    // Set some default values when they are not passed in
    options['label'] = options['label'] || humanize(key)
    options['placeholder'] = options['placeholder'] || options['label']
    options['options'] = options['options'] || []

    // Start the formly templateOptions
    const /** @type {?} */ templateOptions = {
      type: templateType,
    }

    // This are the keys that we need to put into formly's templateOptions
    const /** @type {?} */ toKeys = ['disabled', 'label', 'options', 'placeholder', 'toolbar']

    // Loop over all of the above and set them if found
    toKeys.forEach(toKey => {
      if (options[toKey]) {
        templateOptions[toKey] = options[toKey]
      }
    })

    // Return a formly compatible field
    return {
      key,
      type,
      templateOptions,
      className: options.className || '',
    }
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
input(key: string = null, options: any = {}) {
    return this.field('input', 'text', key, options)
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
email(key: string = null, options: any = {}) {
    return this.field('input', 'email', key, options)
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
password(key: string = null, options: any = {}) {
    return this.field('input', 'password', key, options)
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
date(key: string = null, options: any = {}) {
    return this.field('input', 'date', key, options)
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
textarea(key: string = null, options: any = {}) {
    return this.field('textarea', 'text', key, options)
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
wysiwyg(key: string = null, options: any = {}) {
    return this.field('wysiwyg', 'text', key, options)
  }
/**
 * @param {?=} key
 * @param {?=} options
 * @return {?}
 */
select(key: string = null, options: any = {}) {
    return this.field('select', 'text', key, options)
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxFormsService_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormsService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
